<div *ngIf="currentTrainer" id="trainer-detail-container" class="container">
    <h1>
        <i class="fa fa-user fa-pre" aria-hidden="true"></i>
        {{ currentTrainer.firstName }} {{ currentTrainer.lastName }}
        <div class="reference">{{ currentTrainer.id }}</div>
    </h1>

    <ul class="nav nav-tabs nav-justified" role="tablist">
        <li
            role="presentation"
            class="sessions-calendar"
            [ngClass]="{ active: active === 'detail' }"
        >
            <a
                aria-controls="detail"
                role="tab"
                data-toggle="tab"
                (click)="toggleTab('detail')"
            >
                <h3>{{ 'trainer-detail.details' | translate }}</h3>
            </a>
        </li>
        <li role="presentation" class="session-calendar"
            [ngClass]="{'active': active==='experience'}">
            <a aria-controls="planned-sessions" role="tab" data-toggle="tab"
               (click)="toggleTab('experience')">
                <h3>{{ 'trainer-detail.experiences' | translate }}</h3>
            </a>
        </li>
        <li role="presentation" [ngClass]="{ active: active === 'evaluation' }">
            <a
                aria-controls="evaluation"
                role="tab"
                data-toggle="tab"
                (click)="toggleTab('evaluation')"
            >
                <h3>Evaluation</h3>
            </a>
        </li>
    </ul>

    <br />

    <div class="tab-content">
        <div role="tabpanel" class="tab-pane" id="detail"
             [ngClass]="{'active': active==='detail'}">
            <trainer-detail-description
                [trainer]="currentTrainer"
                (onTrainerSaved)="onTrainerSaved($event)"
                [availableLanguages]="languages"
                type="update">

            </trainer-detail-description>
        </div>

        <div
            role="tabpanel"
            class="tab-pane"
            id="experience"
            [ngClass]="{ active: active === 'experience' }"
        >
            <trainer-detail-skill
                [trainer]="currentTrainer"
            ></trainer-detail-skill>
        </div>

        <div
            role="tabpanel"
            class="tab-pane"
            id="evaluation"
            [ngClass]="{ active: active === 'evaluation' }"
        >
            <trainer-detail-evaluation
                [trainer]="currentTrainer"
            ></trainer-detail-evaluation>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/detail.component.html